import z from "zod";
import { authedEndpoint } from "../../../builder";

export const post = authedEndpoint.mutation(
    ({ id }) => ({
        method: "post",
        url: `remote-storages/${id}/create-test-file`,
    }),
    {
        input: z.object({
            id: z.string(),
        }),
    },
);
